/**
 * 数据字段管理接口
 **/
import { Injectable } from '@angular/core';
import { SwHttpClientService } from 'src/app/librarys/serves/sw-http-client.service';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ConfigDataSourceService {
   //基础平台微服务api
   prefix: string = environment.seekerWebAPI;

   //文件处理微服务api
   filefix: string = environment.fileWebAPI;
 
   //任务调度微服务api
   schedulefix: string = environment.scheduleWebApi;
 
   constructor(
     private http: SwHttpClientService,
     private httpClient: HttpClient,
   ) {
   }

  //#region 数据字段管理接口
  /**
   * 查询数据表字段所有信息
   * @param param
   * @returns {Observable<any>}
   */
  queryColumnDataTablePageList(param) {
    const url = this.prefix + 'dataTable/queryColumnPageList';
    return this.http.Post(url, param);
  }

  /**
   * 更新数据表字段信息
   * @param param
   * @returns {Observable<any>}
   */
  updateTableColumn(param) {
    const url = this.prefix + 'dataTable/updateColumnById';
    return this.http.Post(url, param);
  }

  /**
   * 删除数据表字段单个信息
   * @param param
   * @returns {Observable<any>}
   */
  deleteTableColumn(param) {
    const url = this.prefix + 'dataTable/deleteColumnBatch';
    return this.http.Post(url, param);
  }

  /**
   * 增加数据表单字段个信息
   * @param param
   * @returns {Observable<any>}
   */
  saveTableColumn(param) {
    const url = this.prefix + 'dataTable/saveColumn';
    return this.http.Post(url, param);
  }

  /**
   * 查看数据表字段信息
   * @param param
   * @returns {Observable<any>}
   */
  queryDataTableColumnById(param) {
    const url = this.prefix + 'dataTable/queryColumnById';
    return this.http.Post(url, param);
  }

  //#endregion


}
